module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_020.png
// module id = 2336
// module chunks = 5